import { useCallback, useRef } from 'react';
function useCallbackFn<FN extends (...args: any[]) => any>(fn: FN): FN {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args: any[]) => fnRef.current(...args)) as FN, []);
}

export default useCallbackFn;
